import { SettingsView } from "./_components";

export default function SettingsPage() {
  return <SettingsView />;
}
